import React from 'react'
import {AppBar, MenuItem, Toolbar} from "@material-ui/core";
import {Link} from "react-router-dom";
import resume from "/Users/mikeewers/Desktop/personal-web/src/Img/Michael's Resume.pdf"



class ApplicationBar extends React.Component{
    constructor(props) {
        super(props);
        this.state = {MenuOpen : false}

    }



    render(){
        return(
            <AppBar position={"fixed"} style={{background: '#f5d142'}}>
                <Toolbar>
                    <a href={'/personal-web/#/'} style={{textDecoration: "none", color: 'black'}} ><MenuItem>Home</MenuItem></a>

                    <section style={{marginLeft: 'auto', marginRight: -12}}>
                        <Toolbar>
                            <a style={{textDecoration: "none", color: 'black'}} href={'/personal-web/#/interests'}><MenuItem>Interests</MenuItem></a>
                            <a style={{textDecoration: "none", color: 'black'}} href={resume}><MenuItem>Resume</MenuItem></a>
                            <a style={{textDecoration: "none", color: 'black'}} href={'https://www.linkedin.com/in/mewersdev/'}><MenuItem>LinkedIn</MenuItem></a>
                            <a style={{textDecoration: "none", color: 'black'}} href={'https://github.com/MEwers96'}><MenuItem>Github</MenuItem></a>
                        </Toolbar>
                    </section>
                </Toolbar>
            </AppBar>
        )
    }

}
export default ApplicationBar